import {
  Avatar,
  Box,
  Center,
  Flex,
  HStack,
  Stack,
  Badge,
  Img,
  ScaleFade,
  Text,
  useColorModeValue,
  Alert,
  AlertIcon,
  AlertDescription,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import FullPageLoader from "../../components/FullPageLoader";
import Container from "../../components/Container";
import Header from "../../components/Header";
import { transition } from "../..";
import Footer from "../../components/footer";
import { COLORS } from "../../constants/colors";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { addBtnStyles } from "../issue report";
import { useNavigate, useLocation } from "react-router-dom";
import { PROTECTED_PATHS } from "../../app/constants";
import { getCard, getFamily } from "./services";
import { UserProfileContext } from "../../context/userProfileContext";
import { AuthContext } from "../../context/authContext";
import { PrimaryButton } from "../../components/CustomButton";
import ConfirmCardPayment from "./components/ConfirmCardPayment";
import axiosInstance from "../../services/api";
import PaystackModal from "./components/PaystackModal";
import {
  errorNotifier,
  infoNotifier,
  successNotifier,
} from "../../components/NotificationHandler";
import { FaTimesCircle } from "react-icons/fa";

export const IdCard = ({ onClose }) => {
  const { ID_CARD } = PROTECTED_PATHS;

  const appTextColor = useColorModeValue(COLORS.black, COLORS.white);
  const { userProfile } = useContext(UserProfileContext);
  const { userInfo } = useContext(AuthContext);
  const [family, setFamily] = useState([]);
  const [card, setCard] = useState([]);
  const [loading, setLoading] = useState(false);
  const cardBg = useColorModeValue(COLORS.lightGrey, COLORS.white);
  const cardBg2 = useColorModeValue(COLORS.primary, COLORS.white);

  const [payBtnDisabled, setBtnDisabled] = useState(true);

  const bgColor = useColorModeValue(COLORS.primary, COLORS.green);
  const { REQUEST_ID } = PROTECTED_PATHS;
  const navigate = useNavigate();
  const phone = userProfile?.tenantPhone;
  const location = useLocation();

  const data = location.state?.data || location.state || {};
  const email = data.email || "No email provided";
  const houseNumber =
    data.houseNumber || "No house number available";
  const tenantName = data.tenantName || "No tenant name available";
  const userId = data._id;

  // Filter cards based on their status
  //   const paidCards = card.filter((datum) => datum.isCart === false);
  //   const pendingCards = card.filter((datum) => datum.isCart === true);

  // console.log("Pending Cards are " + pendingCards.length);

  const [paidCards, setPaidCards] = useState([]);
  const [pendingCards, setPendingCards] = useState([]);

  const handleRemove = async (cardId) => {
    try {
      // Send DELETE request to remove the card by ID
      await axiosInstance.delete(`/card/${cardId}`);

      // Optionally: Update state to remove the deleted card from the UI
      setPaidCards((prevCards) =>
        prevCards.filter((card) => card._id !== cardId)
      );
      setPendingCards((prevCards) =>
        prevCards.filter((card) => card._id !== cardId)
      );

      // Notify user of success
      successNotifier("Card removed successfully");
    } catch (error) {
      console.error(
        "Error removing card:",
        error.response?.data || error.message
      );
      errorNotifier("Failed to remove card. Please try again.");
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate("/"); // Redirect to a default page if state is missing
    }

    const fetchCards = async () => {
      try {
        setLoading(true);

        // Fetch Paid Cards
        const paidCardsResponse = await axiosInstance.get(
          `/card?email=${email}&isCart=false`
        );
        setPaidCards(paidCardsResponse.data.result.data.cards.reverse());

        // Fetch Pending Cards
        const pendingCardsResponse = await axiosInstance.get(
          `/card?email=${email}&isCart=true`
        );
        setPendingCards(pendingCardsResponse.data.result.data.cards.reverse());

        // Check conditions for button state
        if (pendingCardsResponse.data.result.data.cards.length > 0) {
          setAllowToOpen(true);
          setBtnDisabled(false);
        } else {
          setAllowToOpen(false);
          setBtnDisabled(true);
        }
      } catch (error) {
        console.error("Error fetching cards:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCards();
    getFamily(userId, setLoading, setFamily);
  }, [userId, email, location.state, navigate]);
  const tabStyles = {
    color: "#031730",
    borderWidth: "2px",
    borderStyle: "solid",
    fontWeight: "bold",
    _selected: {
      color: "#031730",
      borderColor: "#072f64",
      bg: "bgColor",
    },
    _focus: {
      outline: "none",
    },
  };

  const inputStyle = {
    bg: "white",
    rounded: "lg",
    color: "#262636",
  };

  const serviceCharge = 4000;
  const totalServiceCharge = serviceCharge * pendingCards.length;
  const [allowToOpen, setAllowToOpen] = useState(false);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [paymentData, setPaymentData] = useState({});
  const [paymentModal, setPaymentModal] = useState(false);

  const isCart = paidCards.length >= 2;

  const maxFreeCards = 2;
  const usedFreeCards = paidCards.length;
  const remainingFreeCards = Math.max(0, maxFreeCards - usedFreeCards);

  return loading ? (
    <FullPageLoader />
  ) : (
    <ScaleFade initialScale={0.3} in={true} {...transition}>
      <Box>
        <Box shadow="sm">
          <Container>
            <Header />
            <Text fontWeight={"bold"} fontSize={"20px"} color={cardBg2}>
              Welcome {tenantName || "N/A"}
            </Text>
            <Box textAlign="left" color={appTextColor}>
              <Text fontSize="13px">
                House No.:{" "}
                <Text as="span" fontWeight="bold" color="#072f64">
                  {houseNumber || "N/A"}
                </Text>
              </Text>
              <Text fontSize="13px">
                Email Address:{" "}
                <Text as="span" fontWeight="bold" color="#072f64">
                  {email || "N/A"}
                </Text>
              </Text>
            </Box>

            <Alert status="info" bg={cardBg} borderRadius="md" mb={4}>
              <AlertIcon />
              <AlertDescription>
                The first two ID cards are free (covered by the estate). You
                have{" "}
                <Text as="span" fontWeight="bold">
                  {remainingFreeCards}
                </Text>{" "}
                free {remainingFreeCards === 1 ? "card" : "cards"} remaining.
                Additional cards require a payment of{" "}
                <Text as="span" fontWeight="bold">
                  &#8358;4,000
                </Text>
                .
                <Text fontWeight="bold" color="#C53030">
                  Important: Besides free cards, card requests are not processed
                  without payment.
                </Text>
              </AlertDescription>
            </Alert>

            {/* Conditional Button based on card count */}
            <Flex justify="center" mb={6}>
              {/* <BsFillPlusCircleFill
                color={bgColor}
                size={"2.5rem"}
                onClick={() => {
                  const navigationData = {
                    ...data,
                    cardCount: card.length,
                  };
                  navigate(REQUEST_ID, { state: navigationData });
                }}
              /> */}

              {paidCards.length >= 2 ? (
                <PrimaryButton
                  size="sm"
                  onClick={() => {
                    const navigationData = {
                      ...data,
                      cardCount: paidCards.length,
                    };
                    navigate(REQUEST_ID, { state: navigationData });
                  }}
                  btnText="Request for new card"
                  //isDisabled={payBtnDisabled}
                  buttonProps={{ px: "1px" }}
                />
              ) : (
                <PrimaryButton
                  size="sm"
                  onClick={() => {
                    const navigationData = {
                      ...data,
                      cardCount: paidCards.length,
                    };
                    navigate(REQUEST_ID, { state: navigationData });
                  }}
                  btnText="Request for free card"
                  //isDisabled={payBtnDisabled}
                  buttonProps={{ px: "1px" }}
                />
              )}
            </Flex>
          </Container>
        </Box>

        <Flex pt="20px" pb="40px">
          <Container>
            <Tabs isFitted variant="enclosed">
              <TabList mb="1em">
                <Tab {...tabStyles}>Pending Cards</Tab>
                <Tab {...tabStyles}>Paid & Free Cards</Tab>
              </TabList>
              <TabPanels>
                {/* Pending Cards Tab */}
                <TabPanel>
                  {pendingCards.length > 0 ? (
                    <HStack py="20px" justify="space-even" gap="1.5rem">
                      <Stack
                        {...inputStyle}
                        textAlign="center"
                        bg="#c7ebe2"
                        px="15px"
                        w="50%"
                      >
                        <Text as="small">
                          Service Charge{" "}
                          <Badge bg="#c7ebe2" fontWeight="bold" fontSize="7px">
                            &#8358;{serviceCharge} X {pendingCards.length}
                          </Badge>
                        </Text>
                        <Text
                          fontSize="0.9rem"
                          fontWeight="700"
                          m="0 !important"
                        >
                          &#8358;{totalServiceCharge}
                        </Text>
                      </Stack>
                      <ConfirmCardPayment
                        allowToOpen={allowToOpen}
                        buttonProps={{
                          size: "md",
                          _hover: { background: `${COLORS.green}` },
                          _focus: { background: `${COLORS.green}` },
                          bg: `${COLORS.green}`,
                          p: "10px",
                          borderRadius: "10px",
                          color: "white",
                          w: "150px",
                          textAlign: "center",
                          btnText: "Pay", // Pay button shown only if cardCount >= 2
                          isDisabled: payBtnDisabled,
                        }}
                        btnTitle="Pay"
                        addCloseModalBtn={true}
                      >
                        <ConfirmPaymentComponent
                          userProfile={userProfile}
                          userId={data._id}
                          paymentLoading={paymentLoading}
                          family={family}
                          setPaymentData={setPaymentData}
                          setPaymentModal={setPaymentModal}
                          tenantName={tenantName}
                          email={email}
                          totalServiceCharge={totalServiceCharge}
                          isCart={isCart}
                        />
                      </ConfirmCardPayment>
                    </HStack>
                  ) : null}

                  {pendingCards.length > 0 ? (
                    <Box height="300px" overflowY="auto" p="4">
                      <>
                        {pendingCards.map((datum, i) => (
                          <Box
                            key={i}
                            bg={COLORS.chartbg}
                            p="15px"
                            rounded={"lg"}
                            mb="10px"
                          >
                            <Flex
                              justify={"space-between"}
                              w={"100%"}
                              align={"center"}
                            >
                              <Avatar
                                src={datum?.passport}
                                name={datum?.name}
                                alt="profile"
                              />
                              <Text align="center" color={cardBg}>
                                {datum?.name || "N/A"}
                              </Text>

                              <Text
                                fontSize="10px"
                                as="button"
                                color="#fff"
                                bg="#C53030"
                                p={"5px 10px"}
                                rounded={5}
                                onClick={() => handleRemove(datum?._id)}
                                cursor="pointer"
                                display="flex"
                                alignItems="center"
                              >
                                <FaTimesCircle style={{ marginRight: "5px" }} />
                                Remove
                              </Text>
                            </Flex>
                          </Box>
                        ))}
                      </>
                    </Box>
                  ) : (
                    <Center flexDirection="column" h="70vh" w="100%">
                      <Img src="/empty.svg" alt="empty" />
                      <Text
                        py="5"
                        fontWeight="500"
                        textAlign="center"
                        color={appTextColor}
                      >
                        You do not have any pending cards yet
                      </Text>
                    </Center>
                  )}

                  <PaystackModal
                    paymentData={paymentData}
                    paymentModal={paymentModal}
                    setPaymentModal={setPaymentModal}
                    onFinish={() => {
                      axiosInstance
                        .post("/wallet/verify-payment", {
                          userId,
                          reference: paymentData?.reference,
                        })
                        .then(() => {
                          successNotifier("Payment Successful");
                          navigate(ID_CARD, { state: data });
                        })
                        .catch(() => errorNotifier("Payment not Successful"));
                    }}
                    onClose={onClose}
                  />
                </TabPanel>

                {/* Paid Cards Tab */}
                <TabPanel>
                  {paidCards.length > 0 ? (
                    <Box height="300px" overflowY="auto" p="4">
                      <>
                        {paidCards.map((datum, i) => (
                          <Box
                            key={i}
                            bg={COLORS.chartbg}
                            p="15px"
                            rounded={"lg"}
                            mb="10px"
                          >
                            <Flex
                              justify={"space-between"}
                              w={"100%"}
                              align={"center"}
                            >
                              <Avatar
                                src={datum?.passport}
                                name={datum?.name}
                                alt="profile"
                              />
                              <Text align="center" color={cardBg}>
                                {datum?.name || "N/A"}
                              </Text>
                              <Text
                                color={cardBg}
                                bg={COLORS.primary}
                                p={"5px 10px"}
                                rounded={"full"}
                              >
                                {datum?.status || "N/A"}
                              </Text>
                            </Flex>
                          </Box>
                        ))}
                      </>
                    </Box>
                  ) : (
                    <Center flexDirection="column" h="70vh" w="100%">
                      <Img src="/empty.svg" alt="empty" />
                      <Text
                        py="5"
                        fontWeight="500"
                        textAlign="center"
                        color={appTextColor}
                      >
                        You do not have any paid cards yet
                      </Text>
                    </Center>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Container>
        </Flex>
      </Box>
    </ScaleFade>
  );
};

export const ConfirmPaymentComponent = ({
  paymentLoading,
  userId,
  family,
  userProfile,
  setPaymentData,
  setPaymentModal,
  onClose,
  tenantName,
  email,
  totalServiceCharge,
  isCart,
}) => {
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);

  return (
    <Box color={cardBg}>
      <Text fontWeight="bold" mb="4" fontSize={"1.5em"}>
        Confirm Submission
      </Text>
      <Text mb="4">Are you sure you want to submit this request?</Text>
      <PrimaryButton
        size="md"
        isLoading={paymentLoading}
        btnText="Confirm"
        onClick={() => {
          axiosInstance
            .post("/wallet/initialize-payment", {
              amount: totalServiceCharge,
              tenantName: tenantName,
              email: email,
              userId,
              paymentFor: "card",
              isCart: isCart,
            })
            .then((res) => {
              const paymentInfo = res?.data?.result?.data;

              setPaymentData(paymentInfo);

              onClose();

              setPaymentModal(true);
            });
        }}
      />
    </Box>
  );
};
